import { IconProps } from "../../../types/style";

const DolorOutline = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 12 13"
        fill="none"
      >
        <path
          d="M8.5 10.75H3.5C2 10.75 1 10 1 8.25V4.75C1 3 2 2.25 3.5 2.25H8.5C10 2.25 11 3 11 4.75V8.25C11 10 10 10.75 8.5 10.75Z"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M6 8C6.82843 8 7.5 7.32843 7.5 6.5C7.5 5.67157 6.82843 5 6 5C5.17157 5 4.5 5.67157 4.5 6.5C4.5 7.32843 5.17157 8 6 8Z"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M9.5 4H8"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M4 9H2.5"
          stroke={color}
          stroke-miterlimit="10"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
      </svg>
    </div>
  );
};

export default DolorOutline;
